import { render } from "./ContactMomenten.vue?vue&type=template&id=18e0cd1c"
import script from "./ContactMomenten.vue?vue&type=script&lang=js"
export * from "./ContactMomenten.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__